export default "__VITE_ASSET__de4856d8__"